<template>
    <div class="ns-container">
        <el-tabs v-model="activeName" class="ns-tab" @tab-click="handleClick">
            <el-tab-pane label="All Users" name="users">
                All Users
            </el-tab-pane>
            <el-tab-pane label="User Groups" name="users_group">
                <UserGroups />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import UserGroups from "../../components/UI/sections/UserGroups.vue";
export default {
    name: "UsersAndGroups",
    components: {
        UserGroups
    },
    data() {
        return {
            activeName: 'users_group'
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/ns-styles.scss";
</style>